export const userStateKey = 'user';
export const merchantStoreKey = 'merchantStore';
